<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>合同管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backSrc">员工合同</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!showIsAdd && !showIsEdit && !showIsDetail">
      <section class="searchBox">
        <span class="addStyle">
          <a-button v-show="!showIsSearch" @click="showIsSearch = true"
            >显示更多</a-button
          >
          <a-button v-show="showIsSearch" @click="showIsSearch = false"
            >隐藏更多</a-button
          >
          <a-button type="primary" icon="plus" @click="upContractsBtn"
            >上传合同</a-button
          >
        </span>
        <span v-show="showIsSearch">
          <label>状态类型：</label>
          <a-radio-group v-model="type">
            <a-radio :value="1">入职合同</a-radio>
            <a-radio :value="2">离职合同</a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>工作类型：</label>
          <a-radio-group v-model="work_contract_type">
            <a-radio :value="1">长期工合同</a-radio>
            <a-radio :value="2">临时工合同</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>合同状态：</label>
          <a-radio-group v-model="status">
            <a-radio :value="1">需要签署</a-radio>
            <a-radio :value="2">无需签署</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            style="width: 200px"
            placeholder="公司名称／合同名称"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button @click="onReset" style="margin-right: 10px">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          ></span
        >
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data != ''" v-for="(item, i) in data" :key="i">
              <td>{{ item.create_time }}</td>
              <td>{{ item.agreement_name }}</td>
              <td>{{ item.platform_name }}</td>
              <td>
                <p v-show="item.type == 1">入职合同</p>
                <p v-show="item.type == 2">离职合同</p>
              </td>
              <td>
                <p v-show="item.work_contract_type == 1">长期工</p>
                <p v-show="item.work_contract_type == 2">临时工</p>
              </td>
              <td>
                <p v-show="item.is_guard_download == 1">提供员工下载</p>
                <p v-show="item.is_guard_download == 2">员工不可下载</p>
              </td>
              <td>
                <span v-show="item.status == 1">需要签署</span>
                <span v-show="item.status == 2">无需签署</span>
              </td>
              <td>
                <a
                  style="margin-left: 20px;"
                  v-show="item.status == 1"
                  @click="isOpenSign(item.id, 2)"
                  >关闭签署</a
                >
                <a
                  style="margin-left: 20px;"
                  v-show="item.status == 2"
                  @click="isOpenSign(item.id, 1)"
                  >开启签署</a
                >
                <a
                  style="margin-left: 20px;color:#67C23A"
                  @click="editPage(item)"
                  >编辑</a
                >
                <a
                  style="margin-left: 20px;color:#888"
                  @click="detailPage(item)"
                  >详情</a
                >
              </td>
            </tr>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td></td>
              <td>--- 暂无 ---</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 上传 -->
    <addContract v-on:hideInUpContract="hideInUpContract" v-show="showIsAdd" />
    <!-- 上传 end-->
    <!-- 编辑 -->
    <editContract
      v-show="showIsEdit"
      v-on:hideIsEdit="hideIsEdit"
      :editDetail="editDetail"
    />
    <!-- 编辑 end -->
    <!-- 详情 -->
    <detailContract v-show="showIsDetail" :detailVal="detailVal" />
  </div>
</template>
<script>
import axios from "axios";
import addContract from "@/components/contracts/addContract.vue";
import editContract from "@/components/contracts/editContract.vue";
import detailContract from "@/components/contracts/detailContract.vue";
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "上传时间",
        "公司(甲方)名称",
        "合同名称",
        "状态类型",
        "工作类型",
        "下载状态",
        "合同状态",
        "操作"
      ],
      showIsAdd: false,
      showIsEdit: false,
      editDetail: "",
      showIsSearch: false,
      query_field: "",
      type: "",
      work_contract_type: "",
      status: "",
      showIsDetail: false,
      detailVal: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    addContract,
    editContract,
    detailContract
  },
  mounted() {
    this.getData(); //获取列表
  },
  watch: {},
  methods: {
    detailPage(item) {
      this.detailVal = item;
      this.showIsDetail = true;
    },
    onReset() {
      this.query_field = "";
      this.type = "";
      this.work_contract_type = "";
      this.status = "";
      this.page = 1;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    backSrc() {
      this.showIsEdit = false;
      this.showIsAdd = false;
      this.showIsDetail = false;
    },
    hideIsEdit(msg) {
      this.showIsEdit = false;
      if (msg) {
        this.reload();
      }
    },
    editPage(item) {
      this.showIsEdit = true;
      this.editDetail = item;
    },
    hideInUpContract(isShow) {
      this.reload();
      this.showIsAdd = isShow;
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    isOpenSign(id, status) {
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "Sign/setSignStatus";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        id: id,
        status: status
      };
      // console.log(params);
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("操作成功");
            this.reload();
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    },
    getData() {
      this.loading = true;
      let url = this.httpsBasic.url + this.httpsBasic.user + "Sign/getList";
      let params = {
        current_page: this.page,
        per_page: 10,
        token: window.localStorage.getItem("xnwfPcToken"),
        query_field: this.query_field,
        type: this.type,
        work_contract_type: this.work_contract_type,
        status: this.status
      };
      axios
        .post(url, params)
        .then(res => {
          //   console.log(res);
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    upContractsBtn() {
      this.showIsAdd = true;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.searchStyle {
  > input {
    margin: 0 20px;
    width: 200px;
  }
}
table {
  .entryStyle {
    span {
      // margin-right: 20px;
      p {
        display: inline-block;
      }
    }
  }
}
</style>
